/**
 * @module calendlyAnalytics
 */

module.exports = function( Analytics ) {
    function isCalendlyEvent( e ) {
        return e.origin === 'https://calendly.com' && e.data.event && e.data.event.indexOf( 'calendly.' ) === 0;
    }

    window.addEventListener( 'message', function( e ) {
        if ( isCalendlyEvent( e ) ) {
            if ( e.data.event === 'calendly.event_scheduled' ) {
                Analytics.event(
                    {
                        eventCategory: 'Get_a_demo',
                        eventAction: e.data.event.split( '.' )[ 1 ],
                        eventLabel: window.location.pathname,
                    }
                );
            }
        }
    } );
};
